<template>
  <BLayout :colors="$site.colors" :header-title="$t('pages.bot.index.title')" :header-show-back="false">
    <BContainer class="mt-12">
      <a
        v-if="$site.tabs.book"
        class="flex items-center space-x-4  rtl:space-x-reverse p-4 rounded mb-3 text-secondary bg-primary hover:scale-101 cursor-pointer transition-all"
        @click="goReservation"
      >
        <b-icon icon="calendar" class="h-12 w-12 text-primary flex-shrink-0" />
        <div>
          <p class="text-lg font-semibold text-primary">{{ $site.tabs.book.name }}</p>
          <p class="text-sm">{{ $site.tabs.book.information }}</p>
        </div>
      </a>

      <a
        v-if="$site.tabs.timetable"
        class="flex items-center space-x-4  rtl:space-x-reverse p-4 rounded mb-3 text-secondary bg-primary hover:scale-101 cursor-pointer transition-all"
        @click="goTimetable"
      >
        <b-icon icon="timetable" class="h-12 w-12 text-primary flex-shrink-0" />
        <div>
          <p class="text-lg font-semibold text-primary">{{ $site.tabs.timetable.name }}</p>
          <p class="text-sm">{{ $site.tabs.timetable.information }}</p>
        </div>
      </a>

      <a
        v-if="$site.tabs.lastMinute"
        class="flex items-center space-x-4  rtl:space-x-reverse p-4 rounded mb-3 text-secondary bg-primary hover:scale-101 cursor-pointer transition-all"
        @click="goLastMinute"
      >
        <b-icon icon="lastMinute" class="h-12 w-12 text-primary flex-shrink-0" />
        <div>
          <p class="text-lg font-semibold text-primary">{{ $site.tabs.lastMinute.name }}</p>
          <p class="text-sm">{{ $site.tabs.lastMinute.information }}</p>
        </div>
      </a>

      <a
        v-if="$site.tabs.giftCard"
        class="flex items-center space-x-4  rtl:space-x-reverse p-4 rounded mb-3 text-secondary bg-primary hover:scale-101 cursor-pointer transition-all"
        @click="goGiftCard"
      >
        <b-icon icon="giftCard" class="h-12 w-12 text-primary flex-shrink-0" />
        <div>
          <p class="text-lg font-semibold text-primary">{{ $site.tabs.giftCard.name }}</p>
          <p class="text-sm">{{ $site.tabs.giftCard.information }}</p>
        </div>
      </a>

      <a
        v-if="$site.tabs.pass"
        class="flex items-center space-x-4  rtl:space-x-reverse p-4 rounded mb-3 text-secondary bg-primary hover:scale-101 cursor-pointer transition-all"
        @click="goPass"
      >
        <b-icon icon="pass" class="h-12 w-12 text-primary flex-shrink-0" />
        <div>
          <p class="text-lg font-semibold text-primary">{{ $site.tabs.pass.name }}</p>
          <p class="text-sm">{{ $site.tabs.pass.information }}</p>
        </div>
      </a>

      <a
        v-if="$site.tabs.user"
        class="flex items-center space-x-4  rtl:space-x-reverse p-4 rounded mb-3 text-secondary bg-primary hover:scale-101 cursor-pointer transition-all"
        @click="goCustomer"
      >
        <b-icon icon="user" class="h-12 w-12 text-primary flex-shrink-0" />
        <div>
          <p class="text-lg font-semibold text-primary">{{ userTabName }}</p>
          <p class="text-sm">{{ $site.tabs.user.information }}</p>
        </div>
      </a>
    </BContainer>
  </BLayout>
</template>

<script setup lang="ts">
const { $site, $auth } = useNuxtApp()

const errors = ref<any[]>([])

onMounted(async () => {
  const locationStore = useLocationStore()

  try { 
    await locationStore.getServices()
  } catch (e: any) {
    errors.value = e?.errors
  }
})

const userTabName = computed(() => {
  if ($auth.loggedIn) {
    return $auth.user.displayName
  } else {
    return $site.tabs.getName('user', 'Customer')
  }
})

const goReservation = () => {
  navigateTo({ path: '/book-now' })
}

const goTimetable = () => {
  navigateTo({ path: '/timetable' })
}

const goLastMinute = () => {
  navigateTo({ path: '/last-minute' })
}

const goGiftCard = () => {
  navigateTo({ path: '/gift' })
}

const goPass = () => {
  navigateTo({ path: '/pass' })
}

const goCustomer = () => {
  navigateTo({ path: '/customer' })
}

const slideTransition = (to, from) => {
  const order = [
    '/bot',
    '/bot/reservation',
    '/bot/timetable',
    '/bot/lastMinute',
    '/bot/reservation/availability',
    '/bot/reservation/customer',
    '/bot/reservation/confirm'
  ]

  const toIndex = order.indexOf(to.path)
  const fromIndex = (from) ? order.indexOf(from.path) : -1

  let direction = 'right'

  if (fromIndex >= 0) {
    direction = (toIndex > fromIndex) ? 'left' : 'right'
  }

  return {
    mode: 'out-in',
    name: 'slide-' + direction
  }
}
</script>

<style>
.selection-icon {
  font-size: 50px;
  margin: 15px;
  color: var(--bookapp-bg-action);
}

.selection-card {
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

.selection-card:hover {
  transform: translate(0, -2px);
}
</style>
